export default __webpack_public_path__ + "static/media/ben.a8f4ff4f.jpeg";